import {PbxEndpointTreatment} from './pbx_endpoint_treatment'
import {PbxSimRingTreatment} from './pbx_simring'
import {PbxHuntOrderTreatment} from './pbx_hunt_order'
import {PbxIVRMenuTreatment} from './pbx_ivr_menu'
import {PbxTodTreatment} from './pbx_tod'
import { PbxHangupTreatment } from './pbx_hangup'
import {PbxAudioTreatment} from './pbx_audio_treatment'
// import {SMSTreatment} from './sms'
// import {WebhookTreatment} from './webhook'

export class PbxTreatmentFlow extends HTMLElement {
  constructor(domain_id, group_id) {
    super();
    this.domain_id = domain_id;
    this.group_id = group_id;
  }

  validate(required_flow=true) {
    let validationResult = {requiredMissing: false, errorMessages: []}
    if(required_flow || this.children[0].nodeName != "PBX-TREATMENT-ELEMENT") {
      this.children.forEach((element, i) => {
        let elementValidation = element.validate();
        if(elementValidation.requiredMissing) {
          validationResult.requiredMissing = true;
        }
        Array.prototype.push.apply(validationResult.errorMessages, elementValidation.errorMessages);
      });
    }
    return validationResult;
  }

  hasData() {
    return this.children[0].nodeName != "PBX-TREATMENT-ELEMENT";
  }

  getData(child) {
    let current_child = child;
    this.children.forEach((element, i) => {
      if(element.nodeName == "PBX-HANGUP-TREATMENT") {
        // Hangup treatment has no data so continue to POST-CALL-TREATMENT
        return;
      }

      if(element.isTarget()) {
        current_child.destination = element.getData();
      } else if(element.nodeName == "POST-CALL-TREATMENT") {
        current_child.actions.push(...element.getData());
      } else {
        current_child.actions.push(element.getData());
      }

      // Figure out what to do with the next target/action
      if(this.children.length > (i+1) && element.isTarget()) {
        // Check to see if there are child elements.
        let next_child = this.children[i+1].nodeName;
        if(next_child != "PBX-HANGUP-TREATMENT" && next_child != "POST-CALL-TREATMENT" ) {
          current_child.destination.children.push({ivr_option: null, destination: null, actions: []})
          current_child = current_child.destination.children[0];
        }
      }
    });
  }

  renderFlow(child) {
    this.renderImmediateActions(child.target_child_actions);
    this.renderTarget(child.destination);
    if((child.destination != null && child.destination.children != null && child.destination.children.length == 0) && !PbxTreatmentFlow.isEndpoint(child.destination)) {
      this.renderTarget(); // render Hangup
      // let post_call_treatment = document.createElement('post-call-treatment')
      // post_call_treatment.child_actions = child.target_child_actions;
      // this.appendChild(post_call_treatment);
    } else if(!PbxTreatmentFlow.isEndpoint(child.destination)) {
      if(child.destination.children != null) {
        this.renderFlow(child.destination.children[0])
      } else {
        this.renderTarget()
        // let post_call_treatment = document.createElement('post-call-treatment')
        // post_call_treatment.child_actions = child.target_child_actions;
        // this.appendChild(post_call_treatment);
      }
    } else if(PbxTreatmentFlow.isOutboundEndpoint(child.destination) || child.destination == null) {
      // let post_call_treatment = document.createElement('post-call-treatment')
      // post_call_treatment.child_actions = child.target_child_actions;
      // this.appendChild(post_call_treatment);
    }
  }

  renderImmediateActions(child_actions) {
    child_actions.forEach((child_action) => {
      if(child_action.action_timing == 1) {
        let action = child_action.action
        if(action.action_type == SMSTreatment.getType()) {
          let smsAction = document.createElement('sms-treatment');
          smsAction.action = action;
          this.appendChild(smsAction);
        } else if(action.action_type == WebhookTreatment.getType() || action.action_type == WebhookTreatment.getEmailType()) {
          let webhookAction = document.createElement("webhook-treatment");
          webhookAction.action = action;
          this.appendChild(webhookAction);
        } else {
          console.log("Error occured with: " + action)
        }
      }
    });
  }

  renderTarget(target)  {
    if(target == null || typeof target == "undefined") {
      let newElement = document.createElement('pbx-hangup-treatment');
      this.appendChild(newElement);
    }
    else {
      let newElement = null;
      switch(target.target_type) {
        case PbxEndpointTreatment.getType():
          newElement = new PbxEndpointTreatment(this.domain_id, this.group_id);
          break;
        case PbxSimRingTreatment.getType():
          newElement = new PbxSimRingTreatment(this.domain_id, this.group_id);
          break;
        case PbxHuntOrderTreatment.getType():
          newElement = new PbxHuntOrderTreatment(this.domain_id, this.group_id);
          break;
        case PbxIVRMenuTreatment.getType():
          if(target.ivr_choice_timeout == 0) {
            newElement = new PbxAudioTreatment(this.domain_id);
          } else {
            newElement = new PbxIVRMenuTreatment(this.domain_id, this.group_id);
          }
          break;
        case PbxTodTreatment.getType():
          newElement = new PbxTodTreatment(this.domain_id, this.group_id);
      }

      newElement.target = target;
      this.appendChild(newElement)
    }
  }

  replace(oldElement, action_type="") {
    let newElement = null;
    let addNewAction = false; // Some elments allow followup actions.
    let logo = ''
    switch(action_type) {
      case "ring_number":
        newElement = new PbxEndpointTreatment(this.domain_id, this.group_id);
        break;
      case "play_audio":
        addNewAction = true;
        newElement = new PbxAudioTreatment(this.domain_id);
        break;
      case "tod":
        newElement = new PbxTodTreatment(this.domain_id, this.group_id);
        break;
      case "simring":
        newElement = new PbxSimRingTreatment(this.domain_id, this.group_id);
        break;
      case "hunt_order":
        newElement = new PbxHuntOrderTreatment(this.domain_id, this.group_id);
        break;
      // case "sms":
      //   addNewAction = true;
      //   newElement = document.createElement('sms-treatment');
      //   break;
      case "hangup":
        newElement = document.createElement('pbx-hangup-treatment');
        break;
      case "ivr_menu":
        newElement = new PbxIVRMenuTreatment(this.domain_id, this.group_id);
        break;
      // case "webhook":
      //   addNewAction = true;
      //   newElement = document.createElement('webhook-treatment');
      //   break;
      default:
        newElement = document.createElement('pbx-treatment-element');
    }

    if(newElement != null) {
      this.replaceChild(newElement, oldElement);
      if(addNewAction) {
        this.appendChild(document.createElement('pbx-treatment-element'))
      } else if (action_type != "tod" && action_type != "ivr_menu" && action_type != ""){
        // this.appendChild(document.createElement('post-call-treatment'))
      }
      console.log(typeof this.flowChanged  === 'undefined');
      if(!(typeof this.flowChanged  === 'undefined')) {
        this.flowChanged(this, newElement);
      }
    } else {
      console.log("Error occured");
    }
  }

  static isEndpoint(target) {
    let isEndpoint = false;
    if(target == null) {
      isEndpoint = true;
    } else if ([PbxHuntOrderTreatment.getType(), PbxSimRingTreatment.getType(), PbxEndpointTreatment.getType()].includes( target.target_type )) {
      isEndpoint = true;
    } else if (PbxIVRMenuTreatment.getType() == target.target_type && target.ivr_choice_timeout > 0) {
      isEndpoint = true; // Is true IVR not just audio message
    } else if (PbxTodTreatment.getType() == target.target_type) {
      isEndpoint = true; 
    }
    return isEndpoint;
  }

  static isOutboundEndpoint(target) {
    let isEndpoint = false;
    if (target != null && [PbxHuntOrderTreatment.getType(), PbxSimRingTreatment.getType(), PbxEndpointTreatment.getType()].includes( target.target_type )) {
      isEndpoint = true;
    }
    return isEndpoint;
  }
}
customElements.define('pbx-treatment-flow', PbxTreatmentFlow);

export class PbxTreatmentElement extends HTMLElement {
    constructor(show_hangup = false) {
      super();
      this.show_only_actions = false;
      this.show_hangup = show_hangup;

    }

    connectedCallback() {
      this.first_child = this.closest("pbx-treatment-flow").children.length <= 1;
      let flow = this.closest("pbx-treatment-flow");
      this.innerHTML =
      `<div class="col-sm-12 ct_action" data-action_type=NEW>
        <div class="panel panel-default">
          <h4>Choose an Action</h4>
          ${this.show_only_actions ? "" : `
            ${flow.only_post_treatments ? "" : `
          <div class="col-sm-3">
            <div class="well" data-action_type=ring_number>Ring Number
            <i class="fa fa-phone" style="width: 100%; font-size: 2em;"></i>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="well" data-action_type=ivr_menu>Call Menu
            <i class="fa fa-th" style="width: 100%; font-size: 2em;"></i>
            </div>
          </div>
          `}
          <div class="col-sm-3">
            <div class="well" data-action_type=play_audio>Play Audio
            <i class="fa fa-headphones" style="width: 100%; font-size: 2em;"></i>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="well" data-action_type=tod>Schedule
            <i class="fa fa-clock-o" style="width: 100%; font-size: 2em;"></i>
            </div>
          </div>
          ${flow.only_post_treatments ? "" : `
          <div class="col-sm-3">
            <div class="well" data-action_type=simring>Simultaneous Ring
            <i class="fa fa-list" style="width: 100%; font-size: 2em;"></i>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="well" data-action_type=hunt_order>Overflow Routing
            <i class="fa fa-align-right" style="width: 100%; font-size: 2em;"></i>
            </div>
          </div>
          `}
          `}
          <!--div class="col-sm-3">
            <div class="well" data-action_type=sms>Text Message
            <i class="fa fa-comment" style="width: 100%; font-size: 2em;"></i>
            </div>
          </div-->
          <!--div class="col-sm-3">
            <div class="well" data-action_type=webhook>Integration
            <i class="fa fa-cloud-upload" style="width: 100%; font-size: 2em;"></i>
            </div>
          </div-->
          ${(this.first_child || flow.only_post_treatments) && !this.show_hangup ? "" : `
            <div class="col-sm-3">
              <div class="well" data-action_type=hangup>Hang-up
              <i class="fa fa-times-circle" style="width: 100%; font-size: 2em;"></i>
              </div>
            </div>
          `}
        </div>
      </div>`;
      let _this = this;
      this.querySelectorAll(".well").forEach(function(elem) {elem.addEventListener('click', function() {
        _this.closest("pbx-treatment-flow").replace(_this, this.dataset.action_type);
      });});
    }

    validate() {
      // For sure a vaidation error as you cannot have empty targets.
      this.querySelector(".ct_action").classList.add("error");
      return {requiredMissing: true};
    }
  }

  customElements.define('pbx-treatment-element', PbxTreatmentElement);